import React from 'react';

const StepSidebar = ({
  currentStep,
  setStep,
  stepOrder,
  stepDefs,
  frozenScenarios,
  removeScenario,
  onScenarioClick,
  onCalculate,
  onReset,
  onFreeze,
  results,
  isCalculating,
  isLocked = false,
}) => {
  const handleFreeze = () => {
    const defaultName = `Scenario ${(frozenScenarios?.length || 0) + 1}`;
    const name = window.prompt('Name this scenario:', defaultName);
    if (name === null) return;
    onFreeze(name.trim() || defaultName);
  };

  const handleReset = () => {
    if (onReset) {
      onReset();
      window.scrollTo(0, 0);
    }
  };

  const formatTimestamp = (ts) => {
    if (!ts) return '';
    const d = new Date(ts);
    return d.toLocaleString('en-AU', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  };

  return (
    <div className="retirement-sidebar d-flex flex-column p-3">
      <h5 className="sidebar-title mb-4 fw-bold">
        Retirement Planning Steps
      </h5>

      {/* Step Navigation */}
      <nav className="mb-3">
        {stepOrder.map((key, index) => {
          const stepNum = index + 1;
          const isCurrent = stepNum === currentStep;
          const def = stepDefs[key];
          return (
            <div
              key={key}
              onClick={() => setStep(stepNum)}
              className={`sidebar-step-item${isCurrent ? ' active' : ''}`}
            >
              Step {stepNum}: {def.label}
            </div>
          );
        })}
      </nav>

      <hr className="sidebar-divider" />

      {/* Action Buttons */}
      <div className="mb-3 d-flex flex-column gap-2">
        {results && (
          <button
            className="btn btn-sm w-100 sidebar-btn-recalculate"
            onClick={onCalculate}
            disabled={isCalculating || isLocked}
            title={isLocked ? 'Unlock scenario to recalculate' : ''}
          >
            {isCalculating ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Calculating...
              </>
            ) : isLocked ? (
              <>
                <i className="bi bi-lock me-2"></i>
                Locked
              </>
            ) : (
              <>
                <i className="bi bi-arrow-clockwise me-2"></i>
                Recalculate
              </>
            )}
          </button>
        )}

        <button
          className="btn btn-sm w-100 sidebar-btn-reset"
          onClick={handleReset}
        >
          <i className="bi bi-arrow-counterclockwise me-2"></i>
          Reset Calculator
        </button>

        {results && (
          <button
            className="btn btn-sm w-100 sidebar-btn-freeze"
            onClick={handleFreeze}
          >
            <i className="bi bi-bookmark-plus me-2"></i>
            Freeze Scenario
          </button>
        )}
      </div>

      <hr className="sidebar-divider" />

      {/* Frozen Scenarios */}
      <div className="mt-2 flex-grow-1" style={{ overflowY: 'auto' }}>
        <h6 className="small text-uppercase mb-3 sidebar-frozen-label">
          <i className="bi bi-bookmark me-2"></i>
          Frozen Scenarios
        </h6>

        {frozenScenarios.length === 0 ? (
          <p className="small text-muted">
            No saved scenarios yet. Run a calculation and freeze it to compare.
          </p>
        ) : (
          frozenScenarios.map((scenario, index) => (
            <div
              key={index}
              className="frozen-scenario-card d-flex align-items-start justify-content-between"
              onClick={() => onScenarioClick && onScenarioClick(index)}
            >
              <div className="d-flex flex-column">
                <span className="small fw-bold scenario-name">
                  <i className="bi bi-eye me-1"></i>
                  {scenario.name}
                </span>
                {scenario.timestamp && (
                  <span className="scenario-metric">
                    {formatTimestamp(scenario.timestamp)}
                  </span>
                )}
              </div>
              <button
                className="btn btn-sm p-0 border-0 ms-2"
                style={{ color: '#dc3545', lineHeight: 1 }}
                onClick={(e) => {
                  e.stopPropagation();
                  removeScenario(index);
                }}
                title="Remove scenario"
              >
                <i className="bi bi-x-circle"></i>
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default StepSidebar;
